// Canvas resolution (NES-ish); CSS scales 2× with pixelated rendering
export const W = 256;
export const H = 224;
export const DISPLAY_W = W * 2;
export const DISPLAY_H = H * 2;

// Layout
export const HUD_H = 18;
export const PLAY_TOP = HUD_H;
export const PLAY_BOT = H;

// Entity sizes
export const PW = 12; // player width
export const PH = 14; // player height
export const EW = 10; // enemy width
export const EH = 14; // enemy height
export const FB = 4;  // fireball size

// Gameplay tuning
export const PLAYER_SPEED = 72;
export const ENEMY_BASE_SPEED = 25;
export const ENEMY_SPEED_PER_LVL = 1.5;
export const FB_SPEED = 160;
export const FIRE_CD = 0.25;
export const BASE_ENEMIES = 3;
export const MAX_ENEMIES = 50;
export const LEVEL_PAUSE = 2.0;
export const INVINCIBLE_TIME = 1.5;
export const BOOM_DURATION = 0.35;
